import { templateVersionExists, getFormTemplateById } from './utils';

export const getTemplateErrorMessage = (errorType, formTemplates, templateId, versionNo) => {
  const errorMessage = { header: {} };

  switch (errorType) {
    case 'templateVersion':
      errorMessage.header.title = 'ERROR';
      errorMessage.header.subTitle = 'Form Template Version not found';
      errorMessage.friendlyMessage = 'Please select an existing Form Template version.';
      errorMessage.message = templateVersionErrorMessage(formTemplates, templateId, versionNo);
      return errorMessage;

    default:
      return '';
  }
};

export const templateVersionErrorMessage = (formTemplates, templateId, versionNo) => {
  const formTemplate = getFormTemplateById(templateId, formTemplates);

  if (!formTemplate) {
    return `Form Template ID (${templateId}) and Version (${versionNo}) are not found`;
  }
  if (!templateVersionExists(versionNo, formTemplate)) {
    return `Form Template Version (${versionNo}) is not found`;
  }

  return '';
};
